import {BaseEntity} from "./BaseEntity";

export class MapSite implements BaseEntity {
    constructor(
        public id?:number,
        public name?:string,
        public originX = 1,
        public originY = 1){
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.name = json.name;
        this.originX = json.originX;
        this.originY = json.originY;
    }
}
